import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';
import { PanelHeaderProps } from '../../../types/dashboard';
import DashIcon from '../Icon';
import { BACK, CLOSE } from '../../../constants';

export default function PanelHeader({
  cardId,
  title,
  isBeta = false,
  onClose,
}: PanelHeaderProps) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx('widget_header')}>
      <div className={cx('widget_title')}>
        <button
          type="button"
          className={cx('btn', 'backspace')}
          onClick={onClose}
        >
          {BACK}
        </button>
        <DashIcon cardId={cardId} />
        <span className={cx('widget_title_text', { beta: isBeta })}>
          {title}
        </span>
      </div>
      <button type="button" className={cx('btn', 'close')} onClick={onClose}>
        {CLOSE}
      </button>
    </div>
  );
}
